<template>
  <div>
    <div class="main">
      <!-- Right -->
      <div class="main_r">
        <!-- search -->
       <div class="search">
          <div>
            <el-button type="primary" @click="clickBack">返回</el-button>
            <el-select v-model="queryData.trainType" placeholder="训练类型">
              <el-option label="请选择训练类型" value="0"></el-option>
              <el-option label="随心练" value="1"></el-option>
              <el-option label="动作库" value="2"></el-option>
              <el-option label="系统课程" value="3"></el-option>
              <el-option label="训练计划日程" value="4"></el-option>
            </el-select>
            <el-input v-model="queryData.completePercent"  placeholder="请输入完成度"></el-input>
            <el-input v-model="queryData.completeIndicators"  placeholder="请输入几星"></el-input>
            <!-- <el-date-picker v-model="queryData.dayDate" type="date" value-format="yyyy-MM-dd" placeholder="日期" class="mr15"></el-date-picker> -->
            <el-button type="primary" @click="clickQuery">查询</el-button>
            <el-button type="primary" @click="clickQueryReset" plain>重置</el-button>
          </div>
        </div>
        <!-- search End -->

        <!-- 列表 -->
        <el-table :data="dataList" class="mt15 train-report-table" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }" @sort-change="handleSortChange" border>
          <el-table-column prop="trainType" label="训练类型" width="120" sortable="custom" :show-overflow-tooltip="true">
            <template slot-scope="props">
              <span v-if="props.row.trainType == 1">随心练</span>
              <span v-if="props.row.trainType == 2">动作库</span>
              <span v-if="props.row.trainType == 3">系统课程</span>
              <span v-if="props.row.trainType == 4">训练计划日程</span>
            </template>
          </el-table-column>
          <el-table-column prop="actionId" label="动作编号" width="100" sortable="custom" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="courseId" label="课程编号" width="100" sortable="custom" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="planMyDayId" label="训练日程编号" width="120" sortable="custom" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="completePercent" label="完成度" width="90" sortable="custom" :show-overflow-tooltip="true">
            <template slot-scope="props">
              {{props.row.completePercent}}%
            </template>
          </el-table-column>
          <el-table-column prop="completeIndicators" label="完成指标" width="100" sortable="custom" :show-overflow-tooltip="true">
            <template slot-scope="props">
              {{props.row.completeIndicators}}星
            </template>
          </el-table-column>
          <el-table-column prop="trainTime" label="训练时长" width="100" sortable="custom" :show-overflow-tooltip="true">
            <template slot-scope="props">
              {{props.row.trainTime}}秒
            </template>
          </el-table-column>
          <el-table-column prop="weight" label="重量" width="90" sortable="custom" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="outputPower" label="输出功率" width="140" sortable="custom" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="calories" label="卡路里" width="140" sortable="custom" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="numLeft" label="拉动次数" width="180" sortable="custom" :show-overflow-tooltip="true">
            <template slot-scope="props">
              L:{{props.row.numLeft}};R:{{props.row.numRight}};总:{{props.row.numTotal}}
            </template>
          </el-table-column>
          <el-table-column prop="numGroup" label="训练组数" width="100" sortable="custom" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="numDetailLeft1" label="明细完成次数L" width="130" sortable="custom" :show-overflow-tooltip="true">
            <template slot-scope="props">
              {{props.row.numDetailLeft1}}/{{props.row.numDetailLeft2}}
            </template>
          </el-table-column>
          <el-table-column prop="numDetailRight1" label="明细完成次数R" width="130" sortable="custom" :show-overflow-tooltip="true">
            <template slot-scope="props">
              {{props.row.numDetailRight1}}/{{props.row.numDetailRight2}}
            </template>
          </el-table-column>
          <el-table-column prop="weightLeft" label="明细容量L" width="110" sortable="custom" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="weightRight" label="明细容量R" width="110" sortable="custom" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="180" sortable="custom" :show-overflow-tooltip="true"></el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="mt20">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page_no"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="5"
            layout="prev, pager, next, sizes, jumper "
            :total="dataListnum">
          </el-pagination>
        </div>
        <!-- 分页 End -->
      </div>
      <!-- Right End -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {},
  data () {
    return {
      queryData: {
        trainType: '0',
        completePercent: '',
        completeIndicators: '',
        terminalUserId: ''
      },
      // 列表
      dataList: [],
      dataListnum: 0,
      page_no: 1,
      page_size: 5,
      sortField: '',
      sortOrder: ''
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row) {
      this.queryData.terminalUserId = row.id
      this.TrainReportList()
      this.TrainReportNum()
    },
    handleSortChange ({ prop, order }) {
      this.sortField = prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_no = 1
      this.TrainReportList()
      this.TrainReportNum()
    },
    handleSizeChange (val) {
      this.page_size = val
      this.TrainReportList()
      this.TrainReportNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.TrainReportList()
      this.TrainReportNum()
    },
    clickQuery () {
      this.page_no = 1
      this.TrainReportList()
      this.TrainReportNum()
      console.log(this.queryData)
    },
    clickQueryReset () {
      this.queryData.trainType = '0'
      this.queryData.completePercent = ''
      this.queryData.completeIndicators = ''
      this.clickQuery()
    },
    clickBack () {
      this.$emit('triggerFunc', '')
    },
    TrainReportList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.trainType = that.queryData.trainType
      data.completePercent = that.queryData.completePercent
      data.completeIndicators = that.queryData.completeIndicators
      data.terminalUserId = that.queryData.terminalUserId
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TrainReportList, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
          console.log(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    TrainReportNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.trainType = that.queryData.trainType
      data.completePercent = that.queryData.completePercent
      data.completeIndicators = that.queryData.completeIndicators
      data.terminalUserId = that.queryData.terminalUserId
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TrainReportNum, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

  .el-input {
    width: 300px;
    margin-right: 15px;
  }

  .el-select{
    margin-right: 15px;
  }

  .el-button{
    margin-left: 10px;
    margin-right: 10px;
  }
}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      width: 120px;
      margin-right: 15px;
    }

    .el-select{
      margin-right: 15px;
      width: 130px;
    }
  }
}

.el-table thead {
  color: #666;
}

.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: #f7f7f7;
}

/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

// 圆角处理
/deep/ thead tr th:nth-child(1) {
  border-radius: 10px 0 0 0;
}
/deep/ thead tr th:nth-last-child(2) {
  border-radius: 0 10px 0 0;
}

.train-report-table /deep/ .el-table .cell {
  white-space: nowrap;
}
</style>
